import type { CategoryState, LinkTooltipErrorState, LinkTooltipState } from './LinkTooltip.utils'

export const CATEGORY_PAGES = 'Pages'
export const CATEGORY_PRODUCTS = 'Products'

export const SET_IS_VIEW_MODE = 'SET_IS_VIEW_MODE'
export const SET_LINK_DETAILS = 'SET_LINK_DETAILS'
export const SET_CATEGORY_STATE = 'SET_CATEGORY_STATE'

export const SET_IS_EDITING = 'SET_IS_EDITING'

export const SET_ERROR_STATE = 'SET_ERROR_STATE'

export const dropdownCategoryInitialState: CategoryState = {
  selectedCategory: null,
  showCategories: true,
  searchCategory: null,
}

export const initialState: LinkTooltipState = {
  url: '',
  title: '',
  type: '',
  inputValue: '',
  searchTerm: '',
  isExternalLink: false,
  isViewMode: false,
  isEditing: false,
}

export const errorInitialState: LinkTooltipErrorState = {
  hasError: false,
}
